module.exports = __webpack_public_path__ + "static/bnr_wide@3x-8117aab362ae56812115b20bd93096e1.png";